<template>
<q-expansion-item
  v-model="state.unfold"
  class="full-width"
  @show="listen__x__ontoggle($event, true)"
  @hide="listen__x__ontoggle($event, false)">
  <template v-slot:header>
    <q-item-section avatar>
      <q-icon name="label_important" :style="{color:field.color}" />
    </q-item-section>

    <q-item-section>
      <div class="row">
        {{ field.name }}
        <q-space />
        <q-btn unelevated icon="gps_fixed" dense size="xs" @click="listen__focus__onclick">
          <q-tooltip>{{ `이미지 상의 "${field.name}"-판독 영역으로 이동` }}</q-tooltip>
        </q-btn>
      </div>
      <div v-if="mode != 'test'" class="text-caption text-grey">"인식결과가 표시되는 영역입니다."</div>
      <div v-else-if="field.text != undefined" class="text-caption text-grey row">
        {{ `"${field.text}"` }}
        <q-space />
        <span class="text-blue">{{ `${(parseFloat(field.probability) * 100).toFixed(1)}%` }}</span>
      </div>
      <div v-else class="text-caption text-grey row">
        ""
        <q-space />
        <span class="text-red">검출 실패</span>
      </div>
    </q-item-section>
  </template>
  <q-card class="full-width">
    <q-card-section class="full-width" style="padding:10px 32px 16px 32px;">
      <div class="item-row">
        <div>필드 형태</div>
        <div>
          <select v-model="state.type.value" :disabled="mode == 'test'">
            <option v-for="(option, index) in state.type.options" :key="`${index}`" :disabled="option != '기본'" :label="option" :value="option" />
          </select>
        </div>
      </div>
      <div class="item-row">
        <div>좌표</div>
        <div><span class="text-caption text-grey">{{`x1: ${state.rect[0]}, y1: ${state.rect[1]}, x2: ${state.rect[2]}, y2: ${state.rect[3]}`}}</span></div>
      </div>
      <div class="item-row">
        <div>인식 언어</div>
        <div class="badge-wrapper">
          <q-badge v-if="state.language.indexOf('한국어') != -1" color="primary">한국어</q-badge>
          <q-badge v-if="state.language.indexOf('영어') != -1" color="secondary">영어</q-badge>
          <q-badge v-if="state.language.indexOf('숫자') != -1" color="amber">숫자</q-badge>
          <q-badge v-if="state.language.indexOf('특수기호') != -1" color="purple">특수기호</q-badge>
        </div>
      </div>
      <div class="item-row">
        <div>필기 형식</div>
        <div>
          <q-radio v-for="(value, index) in state.writingType.options" :key="`${index}`" size="sm"
            v-model="state.writingType.value" :val="value" :label="value" :disable="mode == 'test'"
          />
        </div>
      </div>
      <div class="item-row">
        <div>사전</div>
        <div>
          <select v-model="state.dictionary.value" :disabled="mode == 'test'">
            <option v-for="(option, index) in state.dictionary.options" :key="`${index}`" :label="option" :value="option" />
          </select>
        </div>
      </div>
      <div class="item-row">
        <div>사전의 가장 유사한 단어로 교체</div>
        <div>
          <q-checkbox left-label v-model="state.dictionary.mustPick" dense size="sm" :disable="mode == 'test'" />
        </div>
      </div>
      <div v-if="mode == 'test'" class="item-row">
        <div>문자열 영역 <span v-if="field.textLength > 1" class="text-caption text-grey">({{`${field.textLength}개`}})</span></div>
        <div v-if="field.candidatePoints != undefined">
          <div><span class="text-caption text-grey">{{`x1: ${field.candidatePoints[0]}, y1: ${field.candidatePoints[1]}, x2: ${field.candidatePoints[2]}, y2: ${field.candidatePoints[3]}`}}</span></div>
        </div>
        <div v-else>
          <div><span class="text-caption text-grey">검출 실패</span></div>
        </div>
      </div>

      <div v-if="mode == 'test' && field.candidateStrings.length > 1" class="my-ul full-width">
        <div v-if="mode == 'test'" class="row">
          <div>차순위 인식 결과</div>
          <div style="flex:0 0 25px" />
          <div class="row col" style="align-items:center;">
            <div class="col" style="height:1px;border-bottom:1px dashed #999999" />
          </div>
        </div>
        <div v-for="(textObj, index) in field.candidateStrings" :key="`${index}`" class="item-row row full-width">
          <div style="flex:0 0 20px" />
          <div>
            <span class="text-white">{{ index + 1 >= 10 ? '' : '1' }}</span>{{index + 1}}.
          </div>
          <div class="col text-grey" style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;min-width:0;">{{`"${textObj[0]}"`}}</div>
          <q-space />
          <div>
            <div><span class="text-blue">{{ `${(parseFloat(textObj[1]) * 100).toFixed(4)}%` }}</span></div>
          </div>
        </div>
      </div>
      <div v-else-if="mode != 'test'" class="item-row">
        <q-space />
        <q-btn flat color="red" icon="delete" label="Delete" dense style="padding:0px 5px;" size="sm" no-caps @click="$emit('onfieldremove', field.id)" />
      </div>
    </q-card-section>
  </q-card>
</q-expansion-item>
</template>
<script>
export default {
  props: ['field', 'mode', 'unfold'],
  data: function () {
    const Vue = this;
    return {
      state: {
        type: {
          options: Vue.$store.getters.fieldTypes,
          value: Vue.field.type
        },
        rect: Vue.field.rect,
        dictionary: {
          options: Vue.$store.getters.fieldDictionaries,
          value: Vue.field.dictionary.name,
          mustPick: Vue.field.dictionary.mustPick,
        },
        language: Vue.field.language,
        writingType: {
          options: Vue.$store.getters.fieldWritingTypes,
          value: Vue.field.writingType
        },
        unfold: Vue.unfold
      }
    }
  },
  methods: {
    listen__focus__onclick: function (e) {
      e.stopPropagation();
      this.$emit('onfocus', this.field.rect)
    },
    listen__x__ontoggle(e, show) {
      if (e != undefined)
        this.$emit('ontoggle', {elment: this.$el, show})
    }
  },
  watch: {
    'field.rect': function (rect) {
      this.state.rect = rect
    },
    'state.type.value': function (value) {
      const Vue = this;
      this.$emit('onfieldvaluechange', {id: Vue.field.id, key: 'type', value})
    },
    'state.dictionary.value': function (value) {
      const Vue = this;
      this.$emit('onfieldvaluechange', {id: Vue.field.id, key: 'dictionary', value: {name: value, mustPick: Vue.state.dictionary.mustPick}})
    },
    'state.dictionary.mustPick': function (value) {
      const Vue = this;
      this.$emit('onfieldvaluechange', {id: Vue.field.id, key: 'dictionary', value: {name: Vue.state.dictionary.value, mustPick: value}})
    },
    'state.language': function (value) {
      const Vue = this;
      this.$emit('onfieldvaluechange', {id: Vue.field.id, key: 'language', value})
    },
    'state.writingType.value': function (value) {
      const Vue = this;
      this.$emit('onfieldvaluechange', {id: Vue.field.id, key: 'writingType', value})
    },
    unfold: function (value) {
      if (value == true || value == false)
        this.state.unfold = value
    }
  }
}
</script>

<style scoped>
.item-row {
  display:flex;
  flex-direction:row;
  height:30px;
  align-items: center;
  justify-content: space-between;
}
.my-ul {
  display:flex;
  flex-direction:column;
  margin-top: 4px;
}
.my-ul > .item-row {
  height: 16px;
  font-size: 12px;
}
.badge-wrapper > *:not(:last-child) {
  margin-right: 3px;
}
</style>
